// extracted by mini-css-extract-plugin
export default {"questionTitle":"question_questionTitle","questionTitle_hasNoCaption":"question_questionTitle_hasNoCaption","alignQuestion":"question_alignQuestion"};